import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { USER_LEVEL_TYPE } from 'constants/common';
import { AdvertisersIcon } from 'components/Atoms/Icon';
import { t } from 'utilities/lang';

const AdvertiserComponent = lazy(() =>
  import('components/Pages/Library/components/Advertisers')
);

export const advertiserRoutes = [
  {
    path: routePath.ADVERTISERS,
    component: AdvertiserComponent,
    exact: true,
    showMenu: true,
    name: `${t('route.my')} ${routeName.ADVERTISERS}`,
    breadcrumbs: [{ name: routeName.LIBRARY }, { name: routeName.ADVERTISERS }],
    icon: AdvertisersIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
